'use strict';

var $               = require('jquery');
var Core            = require('../core/core.js');
var InspectorCCButton = require('./inspector__commoncontrols__button.js');
var InspectorCheckbox = require('./inspector__checkbox.js');

/**
 * Creates an inspector button
 *
 * @class
 */

class InspectorCommonControls extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div class="editor__inspector__item__cc js-inspector__cc">
          <div class="editor__inspector__item__cc__buttons js-inspector__cc__buttons"></div>
          <div class="editor__inspector__item__cc__lock js-inspector__cc__lock"></div>
        </div>
			</div>
		`;

		super.render();
	}

	addButton(title){
		return new InspectorCCButton({
			target: $('.js-inspector__cc__buttons', this.$el),
			fields: {
				'title': title
			}
		});
	}

  addLock() {
		var $target = $('.js-inspector__cc__lock', this.$el);
		$target.addClass('editor__inspector__item__cc__lock--visible');
    return new InspectorCheckbox({
      target: $target,
      fields: {
        'title': "Lock transformation",
      }
    });
  }

}
module.exports = InspectorCommonControls;
